// import logo from './logo.svg';
import "./App.css";
import { Route, Switch } from "react-router-dom";
import Home from "./pages/home/Home";
import Search from "./pages/search/Search";
import Post from "./pages/post/Post";
import Login from "./pages/login/Login";
import Profil from "./pages/profil/Profil";
import React, { useContext } from "react";
import UserContext from "./store/user-context";
import { Redirect } from "react-router-dom";
import CreatePost from "./pages/create-post/CreatePost";
import Loading from "./UI/Loading";
function App() {
  const userContext = useContext(UserContext);
  // // console.log(userContext.login);
  // if (userContext.loading == true) {
  //   return <Loading load={userContext.loading} />;
  // }
  return (
    <React.Fragment>
      <Switch>
        <Route path="/" component={Home} exact />
        <Route path="/search" component={Search} exact />
        <Route path="/post/:idPost" exact>
          <Post />
        </Route>

        <Route path="/login" component={Login} exact />

        <Route path="/create-post" exact>
          {userContext.login == true ? <CreatePost /> : <Redirect to="/" />}
        </Route>

        <Route path="/profil" exact>
          {userContext.login == true ? <Profil /> : <Redirect to="/" />}
        </Route>
      </Switch>
    </React.Fragment>
  );
}

export default App;
